module.exports = {
      id: "environment-usage",
      viewBox: "0 0 28.781 28.787",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#environment",
      toString: function () {
        return this.url;
      }
    }